import { defineComponent as _defineComponent } from 'vue'
import { nextTick, ref, watch } from "vue";
// Types
import { IPicturesAccomodationExtended } from "@/types/index";

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'FullScreenOverlayMobile',
  props: {
    allPrestationsImages: null,
    currentIndex: null,
    totalImages: null,
    isFullScreen: { type: Boolean }
  },
  emits: ["toggleFullScreen", "update:currentIndex"],
  setup(__props: any, { emit }) {

const props = __props as {
  allPrestationsImages: IPicturesAccomodationExtended[];
  currentIndex: number;
  totalImages: number;
  isFullScreen: boolean;
};

// Vue


// Emits


// Data
const localCurrentIndex = ref(props.currentIndex);
const localTotalImages = ref(props.totalImages);

// Refs
const carousel = ref<HTMLElement | null>(null);

// Methods
const toggleFullScreen = () => {
  emit("toggleFullScreen");
};

const getImageUrl = (picture: IPicturesAccomodationExtended) => {
  if (!picture) return "";
  return picture.imgXL || picture.imgLarge || picture.img;
};

const updateIndex = () => {
  if (!carousel.value) return;

  const scrollPosition = carousel.value.scrollLeft;
  const itemWidth = carousel.value.scrollWidth / props.allPrestationsImages.length;
  const newIndex = Math.round(scrollPosition / itemWidth);

  if (newIndex !== localCurrentIndex.value) {
    localCurrentIndex.value = newIndex;
    emit("update:currentIndex", newIndex);
  }
};

/**
 * Scrolls the carousel to the specified index.
 * @param {number} index - The index to scroll to.
 */
const handleScroll = (index:number) => {
  if (carousel.value) {
    const itemWidth = carousel.value.scrollWidth / props.allPrestationsImages.length;
    carousel.value.scrollTo({
      left: index * itemWidth,
      behavior: "auto",
    });
  }
}

// Watchers

/**
 * Watch for changes in the `isFullScreen`. 
 * That is needed to scroll the gallery to the correct image based on the index for the first time the scrollable gallery is open in the Overlay for Mobile.
 * `nextTick` is needed to await for all the images to be in the gallery, otherwise we will not have the correct for `carousel.value.scrollWidth`
 */
watch(
  () => props.isFullScreen,
  () => {
    nextTick(() => {
      if (props.isFullScreen) {
        handleScroll(localCurrentIndex.value)
      }
    })
  }
);

/**
 * Watch for changes in the `currentIndex`. 
 * Used to scroll the gallery to the correct image based on the index
 */
watch(
  () => props.currentIndex,
  (newVal) => {
    localCurrentIndex.value = newVal;
    handleScroll(newVal)
  }
);

watch(
  () => props.totalImages,
  (newVal) => {
    localTotalImages.value = newVal;
  }
);

return { __sfc: true,props, emit, localCurrentIndex, localTotalImages, carousel, toggleFullScreen, getImageUrl, updateIndex, handleScroll }
}

})